import _ from 'lodash';

$(() => {
  bindPaperSelector($('html'));
});

function onChangePaperSelector(e) {
  e.preventDefault();
  var selectedPaper=$(this).val();
  var envellopesPrice = $(this).find(':selected').data('envellopePrice');
  $('.enveloppe_price').text(envellopesPrice);
  $('[data-paper]').addClass('hidden');
  $('[data-paper="'+selectedPaper+'"]').removeClass('hidden');

}

function bindPaperSelector($scope) {
  console.log('binding');
  $scope.find('[data-paper-select=1] select').off('change').on('change', onChangePaperSelector);
  $scope.find('[data-paper-select=1] select').trigger('change');
}

export { bindPaperSelector };
